import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatRupiah = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp0";
  return "Rp" + Number(n).toLocaleString("id-ID");
};

export const formatDate = (iso, locale = "id-ID") => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const formatDateTime = (iso, locale = "id-ID") => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString(locale, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const STAGE_META = {
  new:          { id: "New",          en: "New",         cls: "bg-slate-100 text-slate-700 border-slate-200" },
  contacted:    { id: "Contacted",    en: "Contacted",   cls: "bg-blue-50 text-blue-700 border-blue-200" },
  qualified:    { id: "Qualified",    en: "Qualified",   cls: "bg-purple-50 text-purple-700 border-purple-200" },
  proposal:     { id: "Proposal",     en: "Proposal",    cls: "bg-orange-50 text-orange-700 border-orange-200" },
  negotiation:  { id: "Negotiation",  en: "Negotiation", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  won:          { id: "Won",          en: "Won",         cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  lost:         { id: "Lost",         en: "Lost",        cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

// Fallback style for user-created custom stages
export const stageStyle = (key) => STAGE_META[key]?.cls || "bg-slate-100 text-slate-700 border-slate-200";
export const stageLabel = (key, name) => name || STAGE_META[key]?.id || key;

export const QUAL_META = {
  hot:  { id: "Panas",  en: "Hot",  cls: "bg-rose-50 text-rose-700 border-rose-200" },
  warm: { id: "Hangat", en: "Warm", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  cold: { id: "Dingin", en: "Cold", cls: "bg-sky-50 text-sky-700 border-sky-200" },
};
